import { useCallback } from 'react';
import { calculateContractAmounts } from '@kouto/cart-prices';
import { AVAILABLE_BRAND_FEATURES } from '@kouto/types';

import type { ITax } from 'types/experience.types';
import { isFeatureActive } from 'utils/featureFlag';

export const calculateAdvertisedTierPrice = (
  price: number,
  taxes: ITax[],
  showAdvertisedPrice: boolean,
): number => {
  if (!showAdvertisedPrice) return price;
  const contractTaxLines = taxes.map((tax) => ({
    id: tax.id,
    includedInPrice: tax.includedInPrice,
    showInAdvertisedPrice: tax.showInAdvertisedPrice ?? false,
    percentage: 'percentage' in tax ? tax.percentage : undefined,
    amount: 'amount' in tax ? tax.amount : undefined,
    appliesTo: tax.appliesTo,
    order: tax.order,
  }));
  return calculateContractAmounts(price, contractTaxLines).advertisingAmount;
};

export const useCalculateAdvertisedTierPrice = () => {
  const showAdvertisedPrice = isFeatureActive(
    AVAILABLE_BRAND_FEATURES.ENABLE_SHOW_ADVERTISED_AMOUNT,
  );
  return useCallback(
    (price: number, taxes: ITax[]) =>
      calculateAdvertisedTierPrice(price, taxes, showAdvertisedPrice),
    [showAdvertisedPrice],
  );
};
